<!-- @format -->

<preview>
  <style>
    .no-image {
      background-color: #cccccc;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 300px;
      font-size: 24px;
      font-weight: bold;
      color: white;
    }
    .limited {
      background-color: #6da4ac;
    }
  </style>

  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="/menu/public-info" class="skillsheet">
          公開情報・スキルシート
        </a>
      </li>
      <li class="breadcrumb-item"><h1>プレビュー</h1></li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <section class="contents_area" if="{ state.public_info.name }">
      <div class="contents_block detail">
        <div class="container_profile">
          <div class="box_pic">
            <div class="card">
              <div class="icon">
                <img
                  if="{ !state.public_info.icon }"
                  src="/assets/img/icon_account.svg"
                  alt=""
                />
                <img
                  if="{ state.public_info.icon }"
                  src="{ state.public_info.icon }"
                  alt=""
                />
              </div>
              <div class="current margin-spacing-1_bottom">
                <ul class="preview_list">
                  <li class="preview_list-item">
                    <span class="preview_list-item-title">現在の対応状況:</span>
                    <span class="current-state">
                      { state.public_info.status }
                    </span>
                  </li>
                </ul>
              </div>
              <div
                class="button button-secondary-mini button-white button-chat"
                type="button"
                value="チャット履歴"
              >
                チャット履歴
              </div>
              <div class="button button-secondary margin-spacing-1_top">
                仕事を依頼する
              </div>
            </div>
          </div>
          <!--/.box_pic-->
          <div class="box_text">
            <h2 class="heading-02 heading_normal">
              { state.public_info.name }
            </h2>

            <ul class="preview_list">
              <li class="preview_list-item">
                <span class="preview_list-item-title">生年月日:</span>
                { state.public_info.birthday }
              </li>
              <li class="preview_list-item">
                <span class="preview_list-item-title">性別:</span>
                { state.public_info.sex }
              </li>
              <li class="preview_list-item">
                <span class="preview_list-item-title">居住地:</span>
                { state.public_info.pref }
              </li>
            </ul>

            <!--div class="box_flex02">
              <button
                class="button button-tertiary favorite js-toggle_switch js-check_pair-button margin-spacing-1_right"
              ></button>
              <button
                class="button button-tertiary unfavorite js-toggle_switch js-check_pair-button"
              ></button>
            </div-->

            <h3 class="heading-04 margin-spacing-1_bottom margin-spacing-4_top">
              自己PR
            </h3>
            <p class="comment">
              <template
                each="{ line in state.public_info.description.split('\n')}"
              >
                <span>{ line }</span>
                <br />
              </template>
            </p>
          </div>
          <!--/.box_text-->
        </div>
        <!--/.container_profile-->

        <div class="tab-menu margin-spacing-4_bottom margin-spacing-4_top">
          <ul class="tab-menu-list">
            <li
              each="{ tab in Tabs }"
              if="{ hasTabData(tab.name) }"
              class="tab-menu-list-item { state.tabName==tab.name ? 'is-active' : '' }"
            >
              <a class="js-tab" onclick="{ e => onTab(e, tab.name) }">
                { tab.label }
              </a>
            </li>
          </ul>
        </div>
        <!--/.tab-menu-->

        <div class="tab_contents { state.tabName=='works' ? 'active' : '' }">
          <div class="container_works">
            <a
              class="box_works js-modal-open"
              each="{ work in state.works }"
              onclick="{ e => onWorkModal(e, work) }"
            >
              <template
                if="{ work.limited_publish_level==0 || work.is_authed==1 }"
              >
                <div class="picture">
                  <div if="{ !work.thumbnail }" class="no-image">制作実績</div>
                  <img
                    if="{ work.thumbnail }"
                    src="/public-info/works/api/v1/image?file_hash={ work.thumbnail.hash }"
                    alt=""
                  />
                </div>
                <p class="title_works">{ work.title }</p>
              </template>
              <template
                if="{ work.limited_publish_level==1 && !work.is_authed }"
              >
                <div class="picture">
                  <div class="no-image limited">限定公開</div>
                </div>
                <p class="title_works">{ work.title }</p>
              </template>
            </a>
          </div>
          <!--/.container_works-->
        </div>
        <!--/.tab_contents-->

        <div
          class="tab_contents { state.tabName=='skillsheet' ? 'active' : '' }"
        >
          <template if="{ state.careers.length }">
            <h2 class="heading-03 margin-spacing-2_bottom">経験年数</h2>
            <ul class="exp_list">
              <li class="exp_list-item" each="{ career in state.careers }">
                <span class="exp_list-item-title">{ career.name }</span>
                <span class="exp_list-item-data">
                  経験
                  <span class="exp_list-item-amount">
                    { career.year_number_jname.replace(/^(\d+)(.*)$/, '$1') }
                  </span>
                  { career.year_number_jname.replace(/^(\d+)(.*)$/, '$2') }
                </span>
              </li>
            </ul>
          </template>

          <template if="{ state.medias.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              編集・執筆したことがある媒体
            </h2>
            <template each="{ type in state.medias }">
              <h3 class="heading-05 margin-spacing-2_bottom">{ type.jname }</h3>
              <template each="{ detail in type.list }">
                <h3 class="heading-04 margin-spacing-2_bottom">
                  { detail.jname }
                </h3>
                <ul class="scope_list margin-spacing-2_bottom">
                  <li class="scope_list-item" each="{ media in detail.list }">
                    <span class="skill_label" if="{ media.type !== 'text' }">
                      { media.jname }
                    </span>
                    <span class="skill_label" if="{ media.type === 'text' }">
                      { media.jname }({ media.memo })
                    </span>
                  </li>
                </ul>
              </template>
            </template>
          </template>

          <template if="{ state.industries.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              経験した業種・業界
            </h2>
            <template each="{ group in state.industries }">
              <h3 class="heading-05 margin-spacing-2_bottom">{ group.name }</h3>
              <ul class="scope_list margin-spacing-2_bottom">
                <li class="scope_list-item" each="{ industry in group.list }">
                  <span
                    class="skill_label"
                    if="{ industry.type !== 'textarea' }"
                  >
                    { industry.name }
                  </span>
                  <p
                    class="comment"
                    if="{ industry.type === 'textarea' }"
                    each="{ line in  industry.memo.split('\n') }"
                  >
                    { line }
                  </p>
                </li>
              </ul>
            </template>
          </template>

          <template if="{ state.occupations.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              経験した職種
            </h2>
            <template each="{ major in state.occupations }">
              <h3 class="heading-05 margin-spacing-2_bottom">{ major.name }</h3>
              <template each="{ minor in major.list }">
                <h3 class="heading-04 margin-spacing-2_bottom">
                  { minor.name }
                </h3>
                <ul class="scope_list margin-spacing-2_bottom">
                  <li class="scope_list-item" each="{ unit in minor.list }">
                    <span class="skill_label">{ unit.name }</span>
                  </li>
                </ul>
              </template>
            </template>
          </template>

          <template if="{ state.contents.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              編集・執筆したことがあるコンテンツ・記事
            </h2>
            <template each="{ type in state.contents }">
              <h3 class="heading-05 margin-spacing-2_bottom">{ type.jname }</h3>
              <ul class="scope_list margin-spacing-2_bottom">
                <li class="scope_list-item" each="{ conents in type.list }">
                  <span class="skill_label" if="{ conents.type !== 'text' }">
                    { conents.jname }
                  </span>
                  <span class="skill_label" if="{ conents.type === 'text' }">
                    { conents.jname }({ conents.memo })
                  </span>
                </li>
              </ul>
            </template>
          </template>

          <template if="{ state.skills.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              編集・執筆関連スキル
            </h2>
            <template each="{ type in state.skills }">
              <h3 class="heading-05 margin-spacing-2_bottom">{ type.jname }</h3>
              <ul class="scope_list margin-spacing-2_bottom">
                <li class="scope_list-item" each="{ skill in type.list }">
                  <span class="skill_label" if="{ skill.type !== 'text' }">
                    { skill.jname }
                  </span>
                  <span class="skill_label" if="{ skill.type === 'text' }">
                    { skill.jname }({ skill.memo })
                  </span>
                </li>
              </ul>
            </template>
          </template>
        </div>
        <!--/.tab_contents-->

        <div class="tab_contents { state.tabName=='other' ? 'active' : '' }">
          <template if="{ state.genres.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              関心のあるジャンル
            </h2>
            <ul class="scope_list margin-spacing-2_bottom">
              <li class="scope_list-item" each="{ genre in state.genres }">
                <span class="skill_label">{ genre.name }</span>
              </li>
            </ul>
          </template>

          <template if="{ state.languages.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              扱える言語
            </h2>
            <ul class="scope_list margin-spacing-2_bottom">
              <li
                class="scope_list-item"
                each="{ language in state.languages }"
              >
                <span class="skill_label">{ language.name }</span>
              </li>
            </ul>
          </template>

          <template if="{ state.licenses.length }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              資格
            </h2>
            <template each="{ category in state.licenses }">
              <h3 class="heading-05 margin-spacing-2_bottom">
                { category.jname }
              </h3>
              <ul class="scope_list margin-spacing-2_bottom">
                <li class="scope_list-item" each="{ license in category.list }">
                  <span class="skill_label" if="{ license.type === 'check' }">
                    { license.jname }
                  </span>
                  <span class="skill_label" if="{ license.type === 'select' }">
                    { license.jname } { license.rank_name }
                  </span>
                  <span class="skill_label" if="{ license.type === 'score' }">
                    { license.jname } { license.memo }点
                  </span>
                  <template if="{ license.type === 'textarea' }">
                    <p
                      class="comment"
                      each="{ line in license.memo.split('\n') }"
                    >
                      { line }
                    </p>
                  </template>
                </li>
              </ul>
            </template>
          </template>

          <template if="{ state.hobby || state.sports }">
            <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
              趣味・スポーツ
            </h2>
            <template if="{ state.hobby }">
              <h3 class="heading-05 margin-spacing-2_bottom">趣味</h3>
              <p
                class="comment"
                each="{ line in state.hobby.report_text.split('\n') }"
              >
                { line }
              </p>
            </template>
            <template if="{ state.sports }">
              <h3
                class="heading-05 margin-spacing-2_bottom margin-spacing-4_top"
              >
                スポーツ
              </h3>
              <p
                class="comment"
                each="{ line in state.sports.report_text.split('\n') }"
              >
                { line }
              </p>
            </template>
          </template>
        </div>
        <!--/.tab_contents-->

        <div class="wrap_button margin-spacing-3_top">
          <a
            class="button button-secondary-large button-border margin-spacing-1_right"
            href="/menu/public-info"
          >
            公開情報・スキルシートに戻る
          </a>
        </div>
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <work-modal
    is-open="{ state.workModalIsOpen }"
    on-close="{ e => update({workModalIsOpen: false}) }"
    info="{ state.public_info }"
    work="{ state.work }"
  ></work-modal>

  <script>
    import di from "dependeny-injection";
    import PublicInfoApi from "@model/skillsheet/public-info-api.js";
    import modal from "@tags/modal/menu/work-modal.riot";

    export default {
      components: {
        "work-modal": modal,
      },
      Tabs: [
        { name: "works", label: "制作実績" },
        { name: "skillsheet", label: "経験・スキル" },
        { name: "other", label: "その他" },
      ],
      state: {
        tabName: "",
        workModalIsOpen: false,
        work: {},

        public_info: {},
        works: [],
        careers: [],
        medias: [],
        contents: [],
        skills: [],
        industries: [],
        occupations: [],
        genres: [],
        languages: [],
        licenses: [],
      },
      onBeforeMount() {
        this.PublicInfoApi = new PublicInfoApi();
      },
      async onMounted(state, props) {
        const res = await this.PublicInfoApi.request("preview", "fetch");
        this.update(res);
        for (const tabName of ["works", "skillsheet", "other"]) {
          if (this.hasTabData(tabName)) {
            this.update({ tabName });
            break;
          }
        }
      },
      onWorkModal(e, work) {
        this.update({ work, workModalIsOpen: true });
      },
      onTab(e, tabName) {
        this.update({ tabName });
      },
      hasTabData(tabName) {
        const check = (names) => names.find((e) => this.state[e].length);
        switch (tabName) {
          case "works":
            return check(["works"]);
          case "skillsheet":
            return check([
              "careers",
              "medias",
              "industries",
              "occupations",
              "contents",
              "skills",
            ]);
          case "other":
            return (
              check(["genres", "languages", "licenses"]) ||
              this.state.hobby ||
              this.state.sports
            );
          default:
            return false;
        }
      },
    };
  </script>
</preview>
